<script lang="ts">
  import { Card, QuoteIcon, CardImage, CardText, CardFooter } from '@centerhealth/fe/center-kit';
  import { PlatformTypes, ReviewTypes } from '@centerhealth/fe/center-kit';

  // quote, instagram, facebook, twitter, snapchat
  export let reviewType: ReviewTypes = 'quote';

  // Review's image, an image file path inside "public/assets"
  export let image: string = null;

  // Review's text, can contain html tags
  export let text = '';

  // Author's name of the review
  export let author = '';

  // Author's image
  export let authorAvatar = '';

  // type of the platform (either apple-store or play-store), to show the icon for
  export let platformType: PlatformTypes = '';

  // The original post link on facebook, twitter..etc
  export let postLink = '';
</script>

<div class="review-card p-3 relative">
  <Card variant="secondary" style="padding: 0;">
    {#if reviewType === 'quote'}
      <QuoteIcon />
    {/if}

    {#if image}
      <CardImage {image} {reviewType} />
    {/if}

    {#if text}
      <CardText {text} {platformType} />
    {/if}

    <CardFooter {author} {authorAvatar} {platformType} {postLink} {image} />
  </Card>
</div>

<style>
  .review-card {
    break-inside: avoid;
    padding: 20px;
    @apply relative;
    max-width: 680px;
    @apply self-center;
  }
</style>
